import { render, staticRenderFns } from "./consumptionOrder.vue?vue&type=template&id=684f15db&scoped=true&"
import script from "./consumptionOrder.vue?vue&type=script&lang=ts&"
export * from "./consumptionOrder.vue?vue&type=script&lang=ts&"
import style0 from "./consumptionOrder.vue?vue&type=style&index=0&id=684f15db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684f15db",
  null
  
)

export default component.exports